import React from 'react';
import PropTypes from 'prop-types';

export const FlexContainer = ({ children, paddingLeft, ...props }) => (
  <div style={{ display: 'flex', paddingLeft }} {...props}>
    {children}
  </div>
);

FlexContainer.propTypes = {
  paddingLeft: PropTypes.string,
};
